import { ApiErrorInfo } from 'src/model/component';
import { generateStateContext, useContextSetter } from 'src/utils/context';

interface State {
  errors: ApiErrorInfo[];
  loading: boolean;
}

const initialState: State = {
  errors: [],
  loading: false,
};

export const [AppContext, AppProvider] = generateStateContext(initialState);

export function useAppLoading() {
  const setState = useContextSetter(AppContext);

  return (loading: boolean) => {
    setState({ loading });
  };
}
